export const LS_KEY_SEARCH_FILTER_SUBSCRIPTION = "SEARCH_FILTER_SUBSCRIPTION";

export const LS_KEY_PREFERRED_THEME = "PREFERRED_THEME";
export const LS_KEY_PREFERRED_ALBUM_VIEW_MODE = "PREFERRED_ALBUM_VIEW_MODE";
export const LS_KEY_PREFERRED_GALLERY_VIEW_MODE = "PREFERRED_GALLERY_VIEW_MODE";
export const LS_KEY_PREFERRED_GALLERY_THUMBNAIL_SIZE = "PREFERRED_GALLERY_THUMBNAIL_SIZE";
export const LS_KEY_SELECTED_ALBUM_DURING_ADD_ITEM_OP = "SELECTED_ALBUM_DURING_ADD_ITEM_OP";
